import { Node as CraftNode } from '@candulabs/craft/dist/core/nodes/types';
import { css, PlayCircleIcon, styled } from 'canoe';
import React, { ReactElement } from 'react';

import { FloatingLabel } from '@candu-ai/craft/ui';
import Node from 'craft/components/Node';
import { BuiltInComponents } from 'craft/constants';
import { useCss, useNodeContext, useSelection } from 'craft/hooks';
import { useFlow, useFlowSelectionManager } from 'craft/state';
import { Resolver, ToolboxComponentSections } from 'craft/types';

import { FloatingHeader } from './components/FloatingHeader';

// import { flowInsertNodeTreesAtIndex } from './mutations';

interface Props {
  children: ReactElement;
}

const ConditionalViewNode = styled(({ hasFocus, ...props }) => <Node {...props} />)`
  ${({ theme, hasFocus }) => css`
    position: relative;
    ${hasFocus &&
    css`
      outline: 2px dashed ${theme.colors.BrandPurple} !important;

      &:hover {
        outline: 2px dashed ${theme.colors.BrandPurpleL10} !important;
      }
    `}
  `}
`;

export const ConditionalView: Resolver = ({ children }: Props) => {
  const { id } = useNodeContext();
  const { index } = useFlow(id);
  const { css: cssObj } = useCss([id]);
  const { flexGrow, alignSelf, flexBasis, flexShrink } = cssObj ?? {};
  const { selection } = useSelection();

  const { isFlowDescendantSelected, isFlowStepSelected } = useFlowSelectionManager(id);
  const showLabel = isFlowDescendantSelected && !isFlowStepSelected;
  const hasFocus = selection.all.length === 1 && selection.all[0] === id;

  return (
    <ConditionalViewNode
      overrideCss={{ flexGrow, alignSelf, flexBasis, flexShrink }}
      applyNodeProps={false}
      hasFocus={showLabel}
    >
      {hasFocus && <FloatingHeader id={id} />}
      {showLabel && <FloatingLabel icon={PlayCircleIcon} label="Conditional View" />}
      {/**
       * SUUPER sketchy. this is truly, truly, ugly. figure out
       * how to do it safely
       */}
      {children.props.children[index]}
    </ConditionalViewNode>
  );
};

ConditionalView.craft = {
  name: 'ConditionalView',
  isCanvas: true,
  rules: {
    canDrop(dropTarget, self, helpers): boolean {
      // We can't drop a flow inside another flow, no matter how nested
      const nodeApi = helpers(dropTarget.id);
      const ancestors = nodeApi.ancestors(true);

      if (dropTarget.data.name === BuiltInComponents.Flow) {
        return false;
      }

      if (
        ancestors.find(
          (ancestor) => nodeApi.nodes[ancestor].data.name === BuiltInComponents.ConditionalView,
        )
      ) {
        return false;
      }

      return true;
    },
    canMoveIn: (incomingNodes: CraftNode[]) =>
      incomingNodes.every((node) => node.data.name === BuiltInComponents.ConditionalViewOption),
  },
};

// ConditionalView.mutations = {
// insertNodeTreesAtIndex: flowInsertNodeTreesAtIndex,
// };

ConditionalView.toolbox = {
  schema: {
    [ToolboxComponentSections.Layout]: {
      blockedDisplays: ['inline-block', 'flex'],
    },
  },
};
